import router from '@/router'
import { DEFAULT_SITE_BASE, PATH_SEPARATOR, Router } from '@core/Constants'
import { INSTANCE as ApplicationManager } from '@core/application/ApplicationManager'
import { getAppIdByPath, isMobileTerminal, isInIosAPP } from '@core/Utils'
import { isRouterGuardDisabled } from '@/DebugConfig'
import { useSharedActiveMainHeaderItem } from '@/core/compositions/ActiveMainHeaderItem'
import { useSharedSearchInputActive } from '@/core/compositions/SearchInputActive'

router.beforeEach(async (to, from, next) => {
  if (isRouterGuardDisabled()) return next()

  const { path } = to

  const currentAppId = getAppIdByPath(path, PATH_SEPARATOR) ?? ''

  const isNotMicroApplicationPath =
    path.startsWith(PATH_SEPARATOR + Router.MICRO_APP_MAIN) && !ApplicationManager.hasApp(currentAppId)

  const isMainAppPath = path === Array.of('', Router.MAIN_APP).join(PATH_SEPARATOR)

  const defaultMicroAppId = ApplicationManager.getDefaultMicroAppId()

  const defaultMicroAppPath = defaultMicroAppId
    ? Array.of('', Router.MICRO_APP_MAIN, defaultMicroAppId).join(PATH_SEPARATOR)
    : undefined

  const fileAppId = localStorage.getItem('fileAppId')

  if (await isMobileTerminal()) {
    const { currentSelectedItem, updateCurrentSelectedItem } = useSharedActiveMainHeaderItem()
    const isSearchInputDialogShow = useSharedSearchInputActive()

    if (currentSelectedItem.value !== undefined || isSearchInputDialogShow.value) {
      updateCurrentSelectedItem(undefined)
      isSearchInputDialogShow.value = false
    }

    if (
      from.fullPath !== DEFAULT_SITE_BASE &&
      from.fullPath !== defaultMicroAppPath &&
      to.fullPath === defaultMicroAppPath &&
      from.fullPath.indexOf('deviceId') > -1
    ) {
      window.location.replace(DEFAULT_SITE_BASE)
    }
  }

  if (
    isInIosAPP() &&
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.returnToApp &&
    window.webkit.messageHandlers.returnToApp.postMessage
  ) {
    if (
      from.fullPath !== DEFAULT_SITE_BASE &&
      from.fullPath !== defaultMicroAppPath &&
      to.fullPath === defaultMicroAppPath &&
      from.fullPath.indexOf('deviceId') > -1
    ) {
      window.webkit.messageHandlers.returnToApp.postMessage(null)
    }
  }

  if ((isNotMicroApplicationPath || isMainAppPath) && defaultMicroAppPath) {
    next(defaultMicroAppPath)
  }
  next()
})
